var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeam1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #250503;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 24.93,
    cy: 16.61,
    r: 7.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11.39,
    cy: 21.93,
    r: 5.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 38.5,
    cy: 21.93,
    r: 5.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.97,25.49h0c6.63,0,12.01,5.38,12.01,12.01v2.06c0,.87-.71,1.58-1.58,1.58H14.55c-.87,0-1.58-.71-1.58-1.58v-2.06c0-6.63,5.38-12.01,12.01-12.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m9.84,37.46c0,1.36.42,2.62,1.15,3.67h-5.98c-1.34,0-2.42-1.08-2.42-2.42v-.25c0-4.85,3.96-8.81,8.81-8.81.25,0,.5.01.75.03-1.45,2.07-2.31,4.6-2.31,7.32v.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.31,38.46v.25c0,1.34-1.08,2.42-2.42,2.42h-5.93c.72-1.04,1.15-2.31,1.15-3.67v-.46c0-2.73-.85-5.25-2.31-7.33.23-.02.46-.03.7-.03,4.85,0,8.81,3.97,8.81,8.81Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 50,
    height: 50
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam1);
export default __webpack_public_path__ + "static/media/team-1.91df4010fe2d67395e2bb98d985ebe91.svg";
export { ForwardRef as ReactComponent };